export const highReviewOnboarding = {
  skipLabel: "スキップ",
  discover: {
    title: "ビデオ通話いかがでしたか？",
    // 本文は重要な語句を太字にするため、テキストを分割して保持する
    bodyPrefix: "さがす画面には、",
    bodyHighlight: "評価が高い女の子",
    bodyMiddle: "がリストアップされています。",
    bodyHighlight2: "好みの女の子をタップして",
    bodySuffix: "プロフィールを見に行きましょう。",
    actionHint: "好みの女性を選んでタップしてみましょう",
  },
  callButton: {
    title: "レビューを見て気になったら\n通話リクエストボタンを押してみましょう",
    // 本文は間に下矢印アイコンを挟むため、テキストを3分割して保持する
    bodyPrefix: "通話リクエストは",
    bodyButtonLabel: "「通話する」",
    bodySuffix: "ボタンからできます",
    actionHint: "",
  },
  callConfirm: {
    title: "あと1ステップ",
    body: "通話リクエストを送ると、相手から着信やメッセージが届きます。\n相手の反応を待ちましょう！",
    actionHint: "「ビデオ通話をリクエスト」を押しましょう",
  },
} as const;
